<template>
  <component v-if="componentToRender" :is="componentToRender" v-bind="$attrs" v-on="$listeners"></component>
</template>

<script>
export default {
  name: 'PrivacyPolicyContent',
  data() {
    return {
      componentToRender: null
    }
  },
  created() {
    this.setComponent()
  },
  watch: {
    '$i18n.locale'() {
      this.setComponent()
    }
  },
  methods: {
    setComponent() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'pl'
      this.componentToRender = () => import(`@/components/content/${locale}/PrivacyPolicyContent`).catch(() => import('@/components/content/pl/PrivacyPolicyContent'))
    }
  }
}
</script>

<style scoped>
</style>

